import axios from 'axios'
import { getBpIdParam } from '../../common/helper'
import { buildURL } from '../helper'
import apiConfig from '../../config/apiConfig'

const getGlobalWhatsNew = async () => {
  const bpIdParam = getBpIdParam()
  const { data } = await axios.get(
    `${buildURL('getGlobalWhatsNew', apiConfig.globalWhatsNew)}${bpIdParam}`,
  )
  return data
}

export default getGlobalWhatsNew
